import { render, staticRenderFns } from "./Symbols.vue?vue&type=template&id=da7dda38"
import script from "./Symbols.vue?vue&type=script&setup=true&lang=js"
export * from "./Symbols.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports